import { ProductBlacklistRequest, ProductBlacklistResponse } from '../../../models/api/front/product-blacklist';
import { ApiBaseFront } from '../api-base-front';

// 商品ブラックリスト一覧取得
// PPM単体起動 / OLC それぞれで非表示にする商品（productNameId）を取得する
export class ApiProductBlacklist extends ApiBaseFront<ProductBlacklistResponse> {
  constructor(param: ProductBlacklistRequest) {
    super(
      'GET',
      '/api/v1/product-blacklist',
      'JSON',
      param,
    );
  }
}
